<template>
  <div class="Context" v-title data-title="“北京日”签到">
    <Head :Head="Head"></Head>
    <div class="BorderBottom" style="width:95%">参会人员基本信息</div>
    <el-form :rules="rules" :model="form" ref="form" label-position="right">

      <el-form-item label="本人姓名：" center label-width="100px" prop="name">
        <el-input v-model="form.name" placeholder="请填写姓名" @input="nameChange"></el-input>
      </el-form-item>

      <el-form-item label="单位全称：" label-width="100px" prop="ent">
        <el-input v-model="form.ent" placeholder="请填写单位全称"></el-input>
      </el-form-item>

      <el-form-item label="手机号码：" class="widthAuto" label-width="100px" prop="phone">
        <el-input v-model="form.phone" placeholder="请填写手机号"></el-input>
      </el-form-item>

      <div class="BorderBottom">疫情防控流调信息</div>

      <span class="BlockWidth">一、是否已接种新冠肺炎疫苗？：</span>
      <el-form-item label="" class="Mar20" prop="q6">
        <el-radio-group v-model="form.q6">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <span>二、会前21天内本人有无：</span>
      <el-form-item label="" class="Mar20" prop="q1">
        <span class="BlockWidth">1、发热、咳嗽、腹泻等症状:</span>
        <el-radio-group v-model="form.q1">
          <el-radio :label="1">有</el-radio>
          <el-radio :label="0">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="" class="Mar20" prop="q2">
        <span class="BlockWidth">2、国内中高风险地区旅居史:</span>
        <el-radio-group v-model="form.q2">
          <el-radio :label="1">有</el-radio>
          <el-radio :label="0">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="" class="Mar20" prop="q3">
        <span class="BlockWidth">3、接触新冠肺炎确诊病例、无症状感染者或密切接触者:</span>
        <el-radio-group v-model="form.q3">
          <el-radio :label="1">有</el-radio>
          <el-radio :label="0">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <span class="BlockWidth">三、是否有境外旅居史？：</span>
      <el-form-item label="" class="Mar20" prop="q4">
        <el-radio-group v-model="form.q4">
          <el-radio :label="1">有</el-radio>
          <el-radio :label="0">无</el-radio>
        </el-radio-group>
      </el-form-item>

      <span class="BlockWidth">四、是否为仍处于康复或隔离期的病例、无症状感染者或密接者？：</span>
      <el-form-item label="" class="Mar20" prop="q5">
        <el-radio-group v-model="form.q5">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      

      <el-form-item label="" class="Mar20">
        <el-checkbox v-model="checked" style="width:95%;display:flex;align-items: center;">
          <div style="display:block;width:95%;white-space: normal;word-break: break-all;">
            以上内容属实，如隐瞒、虚报、谎报、本人承担一切法律责任和相应后果。
          </div>
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div style="padding:20px 0px;width:100%;">
      <el-button size="small" style="background:rgb(246,75,0);color:white;font-size:20px;" @click="submit()">签 到
      </el-button>
    </div>
  </div>
</template>

<script>

import {checkComparisonApi, checkEntByNameApi} from "@/api/mobile/enlist";
import Head from '@/components/head.vue';

export default {
  name: "Enlist",
  components: {
    Head
  },
  data() {
    return {
      timer: null,
      EntList: [],
      Head: '参会信息',
      checked: false,
      form: {
        name: '',
        ent: '',
        phone: '',
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: ''
      },
      rules: {
        name: [
          {required: true, message: '请填写本人姓名', trigger: 'blur'}
        ],
        ent: [
          {required: true, message: '请填写单位全称', trigger: 'blur'}
        ],
        phone: [
          {pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请输入合法手机号', trigger: 'blur'}
        ],
        q1: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ],
        q2: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ],
        q3: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ],
        q4: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ],
        q5: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ],
        q6: [
          {required: true, message: '请选择此选项', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    let Data = window.localStorage.getItem('SuccessData');
    if (Data != null) {
      if (JSON.parse(Data).status === 200) {
        this.$router.push({path: '/mobile/success', query: {}});
      } else if (JSON.parse(Data).status === 150) {
        this.$router.push({path: '/mobile/abnormal', query: {}});
      }
    }
  },
  methods: {
    nameChange() {
      let _this = this;
      let params = {
        name: this.form.name
      };
      if (_this.timer !== null) {
        clearTimeout(_this.timer);
      }
      _this.timer = setTimeout(function () {
        checkEntByNameApi({params: params}).then((res) => {
          _this.form.ent = res.data.status === 200 ? res.data.message : '';
        });
      }, 1200);
    },
    submit() {
      if (this.checked) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            checkComparisonApi({params: this.form}).then((res) => {//获取详情
              window.localStorage.setItem('SuccessData', JSON.stringify(res.data))
              if (res.data.status === 201) {
                this.$router.push({path: '/mobile/registered', query: {}});
              } else if (res.data.status === 150) {
                this.$router.push({path: '/mobile/abnormal', query: {}});
              } else if (res.data.status === 200) {
                this.$router.push({path: '/mobile/success', query: {}});
              }
            });
          } else {
            this.$message({
              message: '数据填写有误,请检查数据',
              type: 'error'
            });
          }
        });
      } else {
        this.$message({
          message: '请选中必填项',
          type: 'error'
        });
      }
    }
  }
}
</script>
<style scoped>
.Context {
  width: 100%;
  height: 90%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.BorderBottom {
  height: 44px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgb(246, 75, 0);
  line-height: 44px;
  font-size: 1.3rem;
  margin-right: 0px !important;
  margin-bottom: 20px;
  color: rgb(246, 75, 24);
}

form {
  width: 95%;
  text-align: left;
}

.BlockWidth {
  display: block;
  width: 100%;
}

.el-button {
  width: 80%;
}

.Mar20 {
  margin-left: 10px;
  margin-bottom: 10px;
}

.el-radio-group {
  margin-left: 15px;
}

.el-checkbox__label {
  width: 200px;
  color: red;
}

.el-message {
  min-width: 80% !important;
}

.el-select {
  width: 100% !important;
}
</style>
